// @ts-check
import React from "react"
import SelectAttribute from "features/editor/attributes/SelectAttribute"
import AvailableProperties from "../../properties/AvailableProperties"
import RenderRowAttribute from "../RenderRowAttribute"

/**
 * @type {AttributeItem}
 */
export const selectAvailableProperties = (attributeProps, renderedElementProps = {}) => (
    <RenderRowAttribute
        {...attributeProps}
        render={props => (
            <AvailableProperties deep={false}>
                {properties => (
                    <SelectAttribute
                        {...props}
                        options={properties.map(property => ({
                            value: property,
                            label: property.published_name,
                        }))}
                        {...renderedElementProps}
                    />
                )}
            </AvailableProperties>
        )}
    />
)



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/properties.js